import { render, staticRenderFns } from "./Tipp.vue?vue&type=template&id=2cc4dc6e&scoped=true"
import script from "./Tipp.vue?vue&type=script&lang=js"
export * from "./Tipp.vue?vue&type=script&lang=js"
import style0 from "./Tipp.vue?vue&type=style&index=0&id=2cc4dc6e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4dc6e",
  null
  
)

export default component.exports